import { CREDIT_POOL_ENTRY_TYPES, type CreditPool } from '@vy/api-definition';

export type CreditPoolTrackerTotals = {
  totalCredits: number;
  usedCredits: number;
};

export function creditPoolToTrackerTotals(pool: CreditPool): CreditPoolTrackerTotals {
  const totalCredits = pool.entries.reduce((sum, entry) => {
    return entry.type === CREDIT_POOL_ENTRY_TYPES.GRANT ? sum + entry.amount : sum;
  }, 0);

  const usedCredits = totalCredits - pool.balance;

  return {
    totalCredits,
    usedCredits,
  };
}
